
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.3 8a1.6 1.6 0 011.6 1.6v1.2c0 1.643-1.67 2.8-4.4 2.8-2.73 0-4.4-1.157-4.4-2.8V9.6A1.6 1.6 0 013.7 8h5.6zm4 0a1.6 1.6 0 011.6 1.6v.4c0 1.671-1.254 2.8-3.6 2.8-.113 0-.224-.002-.331-.008a2.971 2.971 0 00.725-1.8l.006-.192V9.6c0-.554-.187-1.064-.502-1.47l-.11-.13H13.3zM6.5 1.6a2.8 2.8 0 110 5.6 2.8 2.8 0 010-5.6zm5.6 1.6a2 2 0 110 4 2 2 0 010-4z"}})])
          )
        }
      }
    